module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "personal_profile"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "profile_text"
  }, [_vm._v("Please complete the following personal profile to assist us in completing your American Academy account.")]), _vm._v(" "), _c('div', {
    staticClass: "personal_top"
  }, [_c('ul', {
    staticClass: "personal_list"
  }, _vm._l((_vm.per_opt), function(item, index) {
    return _c('li', {
      key: index
    }, [(_vm._boardingStep.reachStep.includes(item.step)) ? _c('router-link', {
      class: {
        complete: _vm._boardingStep.doneStep.includes(item.step)
      },
      attrs: {
        "to": item.to,
        "replace": "",
        "active-class": "active",
        "tag": "div"
      }
    }, [_c('span', {
      class: item.addClass
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "step_text"
    }, [_vm._v(_vm._s(item.names))]), _vm._v(" "), _c('em', {
      staticClass: "icon"
    }), _vm._v(" "), _c('b')]) : _c('div', {
      class: {
        complete: _vm._boardingStep.doneStep.includes(item.step)
      }
    }, [_c('span', {
      class: item.addClass
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "step_text"
    }, [_vm._v(_vm._s(item.names))]), _vm._v(" "), _c('em', {
      staticClass: "icon"
    }), _vm._v(" "), _c('b')])], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "basic_information"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('ac')], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('span', [_vm._v("Personal Profile")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64189510"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/onboarding/personal_profile.vue
// module id = 848
// module chunks = 1